import { Component, OnInit, inject } from "@angular/core";
import { DataAccessService } from "../core/services/data-access.service";
import Swal from "sweetalert2";
import { Router, RouterLinkActive, RouterLink } from "@angular/router";
import { MatCard, MatCardContent, MatCardActions, MatCardFooter } from "@angular/material/card";
import { FormsModule } from "@angular/forms";
import { MatFormField, MatLabel, MatPrefix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-forgotpassword",
    templateUrl: "./forgotpassword.component.html",
    styleUrls: ["./forgotpassword.component.scss"],
    imports: [MatCard, MatCardContent, FormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatPrefix, MatCardActions, MatButton, MatCardFooter, RouterLinkActive, RouterLink]
})
export class ForgotPasswordComponent implements OnInit {
  private dataAccess = inject(DataAccessService);
  private router = inject(Router);

  login: string;
  errorMsg: string;

  ngOnInit() {}

  resetPassword() {
    this.dataAccess
      .getJSONPost(
        "reset_password",
        [],
        [
          { k: "p_login", v: this.login },
          { k: "p_case", v: "email" },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          this.errorMsg = data.msg;
        } else {
          Swal.fire({
            icon: "success",
            title: "Request sent!",
            html: "Soon you will receive an email with a link to reset your password.",
            timer: 3000,
            willClose: () => {
              this.router.navigate(["/"]);
            },
          });
        }
      });
  }
}
